import api from "./api";
import { request } from "api/apiSaga";
import { call, takeLatest } from "redux-saga/effects";
import { AnyAction } from "redux";
import types from "./types";

function* fetch(action: AnyAction) {
    yield call(request, api.fetch, action);
}

function* get(action: AnyAction) {
    yield call(request, api.get, action);
}

export default function* saga() {
    yield takeLatest(types.FETCH_REQUEST, fetch);
    yield takeLatest(types.GET_REQUEST, get);
}
